import classes from './Sidebar.module.css';
import React from 'react';
import notes from '../../assets/svg/notes.svg';
import remainders from '../../assets/svg/remainders.svg';
import editlabels from '../../assets/svg/editlabels.svg';
import archive from '../../assets/svg/archiveFaint.svg';
import bin from '../../assets/svg/bin.svg';

export default function Sidebar({ sidebar }) {
  const sidebarclass = sidebar
    ? `${classes.sidebar} ${classes.enter}`
    : `${classes.sidebar} ${classes.exit}`;

  return (
    <section>
      <div className={sidebarclass}>
        <button className={classes.item} autoFocus>
          <img src={notes} alt="" /> <span>Notes</span>
        </button>
        <button className={classes.item}>
          <img src={remainders} alt="" /> <span> Remainders</span>
        </button>
        <button className={classes.item}>
          <img src={editlabels} alt="" /> <span> Edit Labels</span>
        </button>
        <button className={classes.item}>
          <img src={archive} alt="" /> <span> Archive</span>
        </button>
        <button className={classes.item}>
          <img src={bin} alt="" /> <span> Bin</span>
        </button>
      </div>
    </section>
  );
}
